import create from 'zustand';

import { COOKIE_FORCE_IS_EUROPE } from '@/config';
import { EUR, USD } from '@/config/appConstants';
import { GeoClientData } from '@/lib/AbstractAPI/types';
import { Currency } from '@/types';

type GeoLocation = {
  geoLocation: GeoClientData;
  isSet: boolean;
  isEurope: () => boolean;
  getGeoLocation: () => GeoClientData;
  setGeoLocation: (geoLocation: GeoClientData) => void;
  getGeoLocationCurrencyCode: () => Currency;
};

const hasToForceIsEurope = (): boolean => {
  return getCookie(COOKIE_FORCE_IS_EUROPE) == 'true';
};

const getCookie = (cname: string) => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length) !== 'null'
        ? c.substring(name.length, c.length)
        : null;
    }
  }

  return '';
};

export const useGeoLocation = create<GeoLocation>((set, get) => ({
  geoLocation: {} as GeoClientData,
  isSet: false,
  getGeoLocation: (): GeoClientData => {
    return get().geoLocation;
  },

  setGeoLocation: (geoLocation: GeoClientData) => {
    if (geoLocation === get().geoLocation) return;
    set(() => ({
      isSet: true,
      geoLocation: geoLocation,
    }));
  },

  getGeoLocationCurrencyCode: (): Currency => {
    const currency = get().geoLocation.country.currency;

    return currency.toUpperCase() === EUR.toUpperCase() ? EUR : USD;
  },
  isEurope: (): boolean => {
    const forceIsEurope: boolean = hasToForceIsEurope();
    console.log(forceIsEurope);
    return get().geoLocation.isEurope || forceIsEurope;
  },
}));
